import { Pagination, Paper, Table } from '@mui/material';
import { SearchTableBody } from './SearchTableBody';
import { SearchTableHeaders } from './SearchTableHeaders';
import { StandardButton } from '../buttons/StandardButton';
import { useStyles } from '../styles/TableStyles.styles';

import type { Manufacturer } from '@features/redux/slices/designSlice';

interface ManufacturerTableProps {
    selectManufacturer: (manufacturer: Manufacturer) => void;
    manufacturers: Manufacturer[];
    pageCount: number;
    pageNumber: number;
    selectPage: (page: number) => void;
    loadingManufacturer: boolean;
}

const HEADERS = ['Name', ''];

export const ManufacturerTable = ({
    selectManufacturer,
    manufacturers,
    pageCount,
    pageNumber,
    selectPage,
    loadingManufacturer,
}: ManufacturerTableProps) => {
    const styles = useStyles();

    return (
        <Paper>
            <Table>
                <SearchTableHeaders rows={HEADERS} />

                <SearchTableBody
                    numCols={HEADERS.length}
                    emptyListText={!loadingManufacturer ? 'No Manufacturers Found' : ''}
                    loading={loadingManufacturer}
                    rows={manufacturers.map((manufacturer) => {
                        return [
                            {
                                value: manufacturer.manufacturerName,
                                isButton: false,
                            },
                            {
                                value: (
                                    <StandardButton
                                        key={manufacturer.manufacturerName}
                                        text={'Edit'}
                                        onClick={() => selectManufacturer(manufacturer)}
                                    />
                                ),
                                isButton: true,
                            },
                        ];
                    })}
                />
            </Table>

            <div className={styles.pagination}>
                <Pagination
                    color={'primary'}
                    onChange={(_, page) => selectPage(page)}
                    count={pageCount}
                    page={pageNumber}
                />
            </div>
        </Paper>
    );
};
